import api from './api';

export type TipoInsight = 'aviso' | 'acao' | 'dica';

export type AcaoInsight = 'aberto' | 'cta' | 'depois' | 'util' | 'nao_util' | 'por_que' | 'dispensado';

/** Onde o card apareceu: vai para o log de interações. */
export type SuperficieInsight = 'card_dashboard' | 'painel' | 'balao';

export interface InsightItem {
  id: string;
  ids: string[];
  codigoDetector: string;
  tipo: TipoInsight;
  categoria: string;
  titulo: string;
  texto?: string;
  textoCta?: string;
  linkCta?: string;
  urgente: boolean;
  novo: boolean;
  agrupado: boolean;
  quantidade: number;
  porQue?: string;
  detectadoEm: string;
}

export interface InsightsResposta {
  habilitado: boolean;
  total: number;
  itens: InsightItem[];
  /** O insight do balão de hoje, no máximo um por dia. */
  balao?: InsightItem | null;
}

export type PreferenciaCategoria = 'mais' | 'normal' | 'menos' | 'desligado';

export interface PreferenciaCategoriaItem {
  categoria: string;
  nome: string;
  preferencia: PreferenciaCategoria;
  /** De 0 a 1; null enquanto houver poucas avaliações. */
  afinidade?: number | null;
  avaliacoes: number;
}

export interface PreferenciasInsights {
  balaoAtivo: boolean;
  categorias: PreferenciaCategoriaItem[];
}

export const obterInsights = async (limite = 20): Promise<InsightsResposta> => {
  const { data } = await api.get<InsightsResposta>('/Insights', { params: { limite } });
  return data;
};

export const registrarExibicoes = async (ids: string[], superficie: SuperficieInsight, rota: string): Promise<void> => {
  if (ids.length === 0) return;
  await api.post('/Insights/exibicoes', { ids, superficie, rota });
};

export const registrarInteracao = async (
  ids: string[],
  acao: AcaoInsight,
  superficie: SuperficieInsight,
  rota: string,
  posicao?: number
): Promise<void> => {
  await api.post('/Insights/interacao', { ids, acao, superficie, rota, posicao });
};

export const registrarBalao = async (ids: string[], rota: string): Promise<void> => {
  await api.post('/Insights/balao', { ids, rota });
};

export const obterPreferencias = async (): Promise<PreferenciasInsights> => {
  const { data } = await api.get<PreferenciasInsights>('/Insights/preferencias');
  return data;
};

export const salvarPreferencias = async (preferencias: PreferenciasInsights): Promise<void> => {
  await api.put('/Insights/preferencias', preferencias);
};
